(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FloatingContainer", [], factory);
	else if(typeof exports === 'object')
		exports["FloatingContainer"] = factory();
	else
		root["FloatingContainer"] = factory();
})(this, function() {
return 